import i18next from 'i18next'

class PlanService {
  static isTrial(plan: Dto.Plan) {
    return this.isV1(plan) && plan.details.payment.payment_schedule === 5
  }

  static isOnceOff(plan: Dto.Plan) {
    return (
      this.isV1(plan) &&
      [4, 5, 7].includes(plan.details.payment.payment_schedule)
    )
  }

  static isV1(
    plan: Dto.Plan
  ): plan is Dto.Plan & { details: NonNullable<Dto.Plan['details']> } {
    return !!plan.version
  }

  static getPrice(plan: Dto.Plan) {
    if (plan.version === 1) {
      const {
        member_fee: { amount: price },
        term: { type, length },
      } = plan.details!.payment

      return {
        number: price,
        per: i18next.t(
          PlanService.isOnceOff(plan) || length > 1 ? `${type}WithCount` : type,
          {
            count: Number(length),
          }
        ),
      }
    }

    switch (plan.payment_schedule) {
      case null:
      case 'weekly':
        return {
          number: plan.price!,
          per: i18next.t('week', { count: 1 }),
        }

      case 'fortnightly':
        return {
          number: plan.fort_nightly_price,
          per: i18next.t('weekWithCount', { count: 2 }),
        }

      case 'monthly':
        return {
          number: plan.monthly_price,
          per: i18next.t('month', { count: 1 }),
        }

      case 'full':
        return {
          number: plan.full_price,
        }

      default:
        throw new Error(`Unknown payment schedule \`${plan.payment_schedule}\``)
    }
  }

  static getSuspensionFee(plan: Dto.Plan) {
    const { version, details, payment_schedule } = plan

    if (!version) {
      switch (payment_schedule) {
        case 'weekly':
        case 'full':
          return plan.weekly_suspension_fee

        case 'fort_nightly':
          return plan.fort_nightly_suspension_fee

        case 'monthly':
          return plan.monthly_suspension_fee

        default:
          return 0
      }
    }

    return details?.payment.suspension_fee?.amount || 0
  }
}

export { PlanService }
